import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import type { StatsChartData } from '../statsTypes';

interface StatsBarChartProps {
  data: StatsChartData[];
  title: string;
  color?: string;
}

const StatsBarChart: React.FC<StatsBarChartProps> = ({ data, title, color = '#1976D2' }) => {
  const hasData = data.length > 0 && data.some(d => d.value > 0);

  return (
    <div className="stats-chart">
      <h4 className="stats-chart__title">{title}</h4>
      {!hasData ? (
        <p className="stats-chart__empty">No data to display</p>
      ) : (
        <ResponsiveContainer width="100%" height={280}>
          <BarChart data={data} margin={{ top: 10, right: 20, left: 10, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="value" fill={color} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default StatsBarChart;
